import api from './axios';

export const uploadGeneralCaseFileApi = (file) => {
  const form = new FormData();
  form.append('image', file);

  return api.post('/case/add_general_case_file', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

